import * as Yup from "yup";
import { airemissionsCodes } from "../../../../utils/dataAndFormulas/airemissionsForms";

const currentYear = new Date().getFullYear();

export function initialValues(form, period, year, unitsRecorded) {
  return {
    date: form?.date || "",
    period: form?.period || period,
    year: form?.year || year,
    creator_user: form?.creator_user || "",
    state: form?.state || "",
    carbon_dioxide: form?.carbon_dioxide || {
      code: airemissionsCodes["carbon_dioxide"],
      value: 0,
      unit: unitsRecorded?.["carbon_dioxide"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    carbon_monoxide: form?.carbon_monoxide || {
      code: airemissionsCodes["carbon_monoxide"],
      value: 0,
      unit: unitsRecorded?.["carbon_monoxide"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    particulate_material: form?.particulate_material || {
      code: airemissionsCodes["particulate_material"],
      value: 0,
      unit: unitsRecorded?.["particulate_material"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    volatile_organic_compounds: form?.volatile_organic_compounds || {
      code: airemissionsCodes["volatile_organic_compounds"],
      value: 0,
      unit: unitsRecorded?.["volatile_organic_compounds"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    sulfur_oxides: form?.sulfur_oxides || {
      code: airemissionsCodes["sulfur_oxides"],
      value: 0,
      unit: unitsRecorded?.["sulfur_oxides"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    nitrogen_oxides: form?.nitrogen_oxides || {
      code: airemissionsCodes["nitrogen_oxides"],
      value: 0,
      unit: unitsRecorded?.["nitrogen_oxides"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    chlorofluorocarbons: form?.chlorofluorocarbons || {
      code: airemissionsCodes["chlorofluorocarbons"],
      value: 0,
      unit: unitsRecorded?.["chlorofluorocarbons"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrochlorofluorocarbons: form?.hydrochlorofluorocarbons || {
      code: airemissionsCodes["hydrochlorofluorocarbons"],
      value: 0,
      unit: unitsRecorded?.["hydrochlorofluorocarbons"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrofluorocarbons: form?.hydrofluorocarbons || {
      code: airemissionsCodes["hydrofluorocarbons"],
      value: 0,
      unit: unitsRecorded?.["hydrofluorocarbons"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrofluoroolefins: form?.hydrofluoroolefins || {
      code: airemissionsCodes["hydrofluoroolefins"],
      value: 0,
      unit: unitsRecorded?.["hydrofluoroolefins"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    perfluorocarbons: form?.perfluorocarbons || {
      code: airemissionsCodes["perfluorocarbons"],
      value: 0,
      unit: unitsRecorded?.["perfluorocarbons"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    substances_exhaust_ozone_layer: form?.substances_exhaust_ozone_layer || {
      code: airemissionsCodes["substances_exhaust_ozone_layer"],
      value: 0,
      unit: unitsRecorded?.["substances_exhaust_ozone_layer"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    ozone: form?.ozone || {
      code: airemissionsCodes["ozone"],
      value: 0,
      unit: unitsRecorded?.["ozone"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    toxic_or_dangerous_atmospheric_pollutants:
      form?.toxic_or_dangerous_atmospheric_pollutants || {
        code: airemissionsCodes["toxic_or_dangerous_atmospheric_pollutants"],
        value: 0,
        unit:
          unitsRecorded?.["toxic_or_dangerous_atmospheric_pollutants"] || "",
        pollulant: "",
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    ammonia: form?.ammonia || {
      code: airemissionsCodes["ammonia"],
      value: 0,
      unit: unitsRecorded?.["ammonia"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    propane: form?.propane || {
      code: airemissionsCodes["propane"],
      value: 0,
      unit: unitsRecorded?.["propane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    isobutane: form?.isobutane || {
      code: airemissionsCodes["isobutane"],
      value: 0,
      unit: unitsRecorded?.["isobutane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    propylene: form?.propylene || {
      code: airemissionsCodes["propylene"],
      value: 0,
      unit: unitsRecorded?.["propylene"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    ethylene: form?.ethylene || {
      code: airemissionsCodes["ethylene"],
      value: 0,
      unit: unitsRecorded?.["ethylene"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hexafluoroethane: form?.hexafluoroethane || {
      code: airemissionsCodes["hexafluoroethane"],
      value: 0,
      unit: unitsRecorded?.["hexafluoroethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    octafluoropropane: form?.octafluoropropane || {
      code: airemissionsCodes["octafluoropropane"],
      value: 0,
      unit: unitsRecorded?.["octafluoropropane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    chlorotrifluoromethane: form?.chlorotrifluoromethane || {
      code: airemissionsCodes["chlorotrifluoromethane"],
      value: 0,
      unit: unitsRecorded?.["chlorotrifluoromethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    chlorodifluoromethane: form?.chlorodifluoromethane || {
      code: airemissionsCodes["chlorodifluoromethane"],
      value: 0,
      unit: unitsRecorded?.["chlorodifluoromethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    tetrafluoroethane: form?.tetrafluoroethane || {
      code: airemissionsCodes["tetrafluoroethane"],
      value: 0,
      unit: unitsRecorded?.["tetrafluoroethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    trifluoromethane: form?.trifluoromethane || {
      code: airemissionsCodes["trifluoromethane"],
      value: 0,
      unit: unitsRecorded?.["trifluoromethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    pentafluoroethane: form?.pentafluoroethane || {
      code: airemissionsCodes["pentafluoroethane"],
      value: 0,
      unit: unitsRecorded?.["pentafluoroethane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hexafluoropropylene: form?.hexafluoropropylene || {
      code: airemissionsCodes["hexafluoropropylene"],
      value: 0,
      unit: unitsRecorded?.["hexafluoropropylene"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrogen: form?.hydrogen || {
      code: airemissionsCodes["hydrogen"],
      value: 0,
      unit: unitsRecorded?.["hydrogen"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    methane: form?.methane || {
      code: airemissionsCodes["methane"],
      value: 0,
      unit: unitsRecorded?.["methane"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    oxygen: form?.oxygen || {
      code: airemissionsCodes["oxygen"],
      value: 0,
      unit: unitsRecorded?.["oxygen"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    nitrogen: form?.nitrogen || {
      code: airemissionsCodes["nitrogen"],
      value: 0,
      unit: unitsRecorded?.["nitrogen"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrogen_sulfide: form?.hydrogen_sulfide || {
      code: airemissionsCodes["hydrogen_sulfide"],
      value: 0,
      unit: unitsRecorded?.["hydrogen_sulfide"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    carbon_disulfide: form?.carbon_disulfide || {
      code: airemissionsCodes["carbon_disulfide"],
      value: 0,
      unit: unitsRecorded?.["carbon_disulfide"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    nitrous_oxide: form?.nitrous_oxide || {
      code: airemissionsCodes["nitrous_oxide"],
      value: 0,
      unit: unitsRecorded?.["nitrous_oxide"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrochlorofluorocarbons_ref: form?.hydrochlorofluorocarbons_ref || {
      code: airemissionsCodes["hydrochlorofluorocarbons_ref"],
      value: 0,
      unit: unitsRecorded?.["hydrochlorofluorocarbons_ref"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrofluorocarbons_ref: form?.hydrofluorocarbons_ref || {
      code: airemissionsCodes["hydrofluorocarbons_ref"],
      value: 0,
      unit: unitsRecorded?.["hydrofluorocarbons_ref"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    hydrofluoroolefins_ref: form?.hydrofluoroolefins_ref || {
      code: airemissionsCodes["hydrofluoroolefins_ref"],
      value: 0,
      unit: unitsRecorded?.["hydrofluoroolefins_ref"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    perfluorocarbonos_ref: form?.perfluorocarbonos_ref || {
      code: airemissionsCodes["perfluorocarbonos_ref"],
      value: 0,
      unit: unitsRecorded?.["perfluorocarbonos_ref"] || "",
      pollulant: "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    // r_22: form?.r_22 || {
    //   code: airemissionsCodes["r_22"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_22"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_123: form?.r_123 || {
    //   code: airemissionsCodes["r_123"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_123"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_134a: form?.r_134a || {
    //   code: airemissionsCodes["r_134a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_134a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_404a: form?.r_404a || {
    //   code: airemissionsCodes["r_404a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_404a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_407a: form?.r_407a || {
    //   code: airemissionsCodes["r_407a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_407a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_407c: form?.r_407c || {
    //   code: airemissionsCodes["r_407c"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_407c"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_410a: form?.r_410a || {
    //   code: airemissionsCodes["r_410a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_410a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_417a: form?.r_417a || {
    //   code: airemissionsCodes["r_417a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_417a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_422d: form?.r_422d || {
    //   code: airemissionsCodes["r_422d"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_422d"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_427a: form?.r_427a || {
    //   code: airemissionsCodes["r_427a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_427a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_438a: form?.r_438a || {
    //   code: airemissionsCodes["r_438a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_438a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_507a: form?.r_507a || {
    //   code: airemissionsCodes["r_507a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_507a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_11: form?.r_11 || {
    //   code: airemissionsCodes["r_11"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_11"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_12: form?.r_12 || {
    //   code: airemissionsCodes["r_12"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_12"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_113: form?.r_113 || {
    //   code: airemissionsCodes["r_113"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_113"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_114: form?.r_114 || {
    //   code: airemissionsCodes["r_114"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_114"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_115: form?.r_115 || {
    //   code: airemissionsCodes["r_115"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_115"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_600a: form?.r_600a || {
    //   code: airemissionsCodes["r_600a"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_600a"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_290: form?.r_290 || {
    //   code: airemissionsCodes["r_290"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_290"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_717: form?.r_717 || {
    //   code: airemissionsCodes["r_717"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_717"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_718: form?.r_718 || {
    //   code: airemissionsCodes["r_718"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_718"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
    // r_744: form?.r_744 || {
    //   code: airemissionsCodes["r_744"],
    //   value: 0,
    //   unit: unitsRecorded?.["r_744"] || "",
    //   pollulant: "",
    //   reviews: [],
    //   approvalStatus: "pending",
    //   files: [],
    // },
  };
}

// export function initialValues(form, period, year) {
//   return {
//     date: form?.date || "",
//     period: form?.period || period,
//     year:form?.year || year,
//     creator_user: form?.creator_user || "",
//     state: form?.state || "",
//     spinning_of_threads: form?.spinning_of_threads || {
//       code:airemissionsCodes["spinning_of_threads"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     finishings: form?.finishings || {
//       code:airemissionsCodes["finishings"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     solvents:form?.solvents || {
//       code:airemissionsCodes["solvents"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     adhesives_cementation:form?.adhesives_cementation || {
//       code:airemissionsCodes["adhesives_cementation"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     impression:form?.impression || {
//       code:airemissionsCodes["impression"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     tincture:form?.tincture || {
//       code:airemissionsCodes["tincture"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     tension_frames_or_other_heating_processes:form?.tension_frames_or_other_heating_processes || {
//       code:airemissionsCodes["tension_frames_or_other_heating_processes"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     stain_cleaners:form?.stain_cleaners || {
//       code:airemissionsCodes["stain_cleaners"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     chemicals:form?.chemicals || {
//       code:airemissionsCodes["chemicals"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     ods:form?.ods || {
//       code:airemissionsCodes["ods"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     pm:form?.pm || {
//       code:airemissionsCodes["pm"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     vocs:form?.vocs || {
//       code:airemissionsCodes["vocs"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     hap_tap:form?.hap_tap || {
//       code:airemissionsCodes["hap_tap"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     boiler:form?.boiler || {
//       code:airemissionsCodes["boiler"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     generators:form?.generators || {
//       code:airemissionsCodes["generators"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     combustion_engines:form?.combustion_engines || {
//       code:airemissionsCodes["combustion_engines"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     industrial_ovens:form?.industrial_ovens || {
//       code:airemissionsCodes["industrial_ovens"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     heating_and_ventilation:form?.heating_and_ventilation || {
//       code:airemissionsCodes["heating_and_ventilation"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     refrigerant_containing_device:form?.refrigerant_containing_device || {
//       code:airemissionsCodes["refrigerant_containing_device"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     air_conditioning:form?.air_conditioning || {
//       code:airemissionsCodes["air_conditioning"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     },
//     other_sources_operations_facilities:form?.other_sources_operations_facilities || {
//       code:airemissionsCodes["other_sources_operations_facilities"],
//          value:0,     unit: unitsRecorded?.["sludge_treatment_cost"] || "",
//       pollulant:"",
//       reviews:[
//       ],
//       approvalStatus: "pending",
//       files:[]
//     }
//   };
// }

export function validationSchema() {
  return Yup.object({
    period: Yup.string("Dato requerido").required(
      "El campo periodo es obligatorio"
    ),
    carbon_dioxide: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    carbon_monoxide: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    particulate_material: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    volatile_organic_compounds: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    sulfur_oxides: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    nitrogen_oxides: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    chlorofluorocarbons: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    hydrochlorofluorocarbons: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    hydrofluorocarbons: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       hydrofluoroolefins: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       perfluorocarbons: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       substances_exhaust_ozone_layer: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       ozone: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       toxic_or_dangerous_atmospheric_pollutants: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       ammonia: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       propane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       isobutane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       propylene: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       ethylene: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       hexafluoroethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       octafluoropropane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),       chlorotrifluoromethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         chlorodifluoromethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         tetrafluoroethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         trifluoromethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         pentafluoroethane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         hexafluoropropylene: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         hydrogen: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         methane: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         oxygen: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         nitrogen: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         hydrogen_sulfide: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       carbon_disulfide: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       nitrous_oxide: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       hydrochlorofluorocarbons_ref: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
       hydrofluorocarbons_ref: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         hydrofluoroolefins_ref: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
         perfluorocarbonos_ref: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  });
}
